var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 41 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shopping_bag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.609 10h-3.334a6.665 6.665 0 0 0-6.666-6.667A6.665 6.665 0 0 0 13.942 10H10.61a3.343 3.343 0 0 0-3.334 3.333v20c0 1.834 1.5 3.334 3.334 3.334h20c1.833 0 3.333-1.5 3.333-3.334v-20c0-1.833-1.5-3.333-3.333-3.333m-10-3.333c1.833 0 3.333 1.5 3.333 3.333h-6.667c0-1.833 1.5-3.333 3.334-3.333m10 26.666h-20v-20h3.333v3.334c0 .916.75 1.666 1.667 1.666.916 0 1.666-.75 1.666-1.666v-3.334h6.667v3.334c0 .916.75 1.666 1.667 1.666.916 0 1.666-.75 1.666-1.666v-3.334h3.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shopping_bag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.609 0h40v40h-40z"
  })))));
};
export default SvgShoppingBag;